/** @format */
import { useEffect } from "react";
import { Layout } from "../../components/common/Layout";
import NotFound from "../../components/NotFound/NotFound";
import { useCookies } from "react-cookie";

export default function TrendDetails({ res, error, trend }) {
  const [cookie, setCookie] = useCookies(["qalaraUser"]);

  // set cookie to identify if it's new user on site or old user
  useEffect(() => {
    if (cookie.qalaraUser && cookie.qalaraUser === "newUser") {
      setCookie("qalaraUser", "oldUser", {
        path: "/",
        maxAge: 60 * 60 * 24 * 30,
      });
    } else {
      !cookie.qalaraUser &&
        setCookie("qalaraUser", "newUser", {
          path: "/",
          maxAge: 60 * 60 * 24 * 30,
        }); // set to expire in 30
    }
    return function cleanup() {
      console.log("returned");
    };
  }, []);

  const trendTitle = trendsLabelObj[trend] || trend || "";
  const trendDesc =
    trendsLabelDesc[trend] ||
    "Source from wholesale suppliers who believe in conscious production, sustainable supply chains. From India & South Asia";

  const meta = {
    title: `Qalara | Global sourcing & wholesale | B2B market | ${trendTitle}`,
    description: trendDesc,
    url: "/trends/" + trend + "/",
  };

  let { body = "" } = res || {};
  if (error?.status || res?.body == null) {
    return (
      <>
        <NotFound />
      </>
    );
  }
  return (
    <Layout meta={meta}>
      {/*(cookie.qalaraUser && cookie.qalaraUser !== 'oldUser') && <FeedbackModal />*/}
      <div
        dangerouslySetInnerHTML={{
          __html: body,
        }}
      ></div>
    </Layout>
  );
}
const trendsObj = {
  earthinspired: "earthinspired",
  globaltextures: "GlobalTextures",
  urbanjungle: "UrbanJungle",
  homeoffice: "HomeOffice",
  christmasspirit: "ChristmasSpirit",
  "sunkissed-spring21": "SpringSummer",
  "play-and-learn": "KidsLearning",
  indigoblues: "IndigoBlues",
  farmhousedecor: "FarmhouseDecor",
  monochrome: "Monochrome",
  "minimalist-vibes": "MinimalistVibes",
  "eclectic-pop": "EclecticPop",
  oceanbreeze: "OceanBreeze",
  noir: "Noir",
  "tender-rose": "Rose",
  "joyful_basics": "Joyful Basics",
  "floral-country-side": "Floral countryside",
  "hyper-crafted": "Hypercrafted",
  "ombre_gradient": "Ombre & Gradients"
};
const trendsLabelObj = {
  earthinspired: "Earth Inspired",
  globaltextures: "Global Textures",
  urbanjungle: "Urban Jungle",
  homeoffice: "Home Office",
  christmasspirit: "Holiday Spirit",
  "sunkissed-spring21": "Summer Pastels",
  "play-and-learn": "Kids Learning",
  indigoblues: "Blue Hues",
  farmhousedecor: "Farmhouse",
  monochrome: "Monochrome",
  "minimalist-vibes": "Minimalist Vibes",
  "eclectic-pop": "Eclectic Pop",
  oceanbreeze: "Ocean Breeze",
  noir: "Noir",
  "tender-rose": "Rose",
  joyful_basics: "Joyful Basics",
};

const trendsLabelDesc = {
  earthinspired:
    "Source from wholesale suppliers who believe in conscious production, sustainable supply chains. From India & South Asia",
  globaltextures:
    "Shop wholesale Boho cushions, rugs, throws, bags & decor; crafted by hand picked Indian & South Asian suppliers, combining local crafts with modern aesthetics",
  urbanjungle:
    "Buy wholesale woven baskets & planters, upcycled wall decor, garden furniture, storage units in green materials such as bamboo, jute, clay & dried grass fibres",
  homeoffice:
    "Global online wholesale platform to source handmade & sustainable Décor, Homeware, Rugs, Vases, Candles, Toys, Jewelry items in bulk from India & Southeast Asia",
  christmasspirit:
    "Shop this curated selection of candle stands, candles, ornaments, cushion covers, and kitchenware to help your customers spread the holiday cheer.",
  "sunkissed-spring21":
    "Shop wholesale dresses, coordinated sets, comfortable footwear & masks; these must-haves will definitely awe your customers, so start stocking for Summer!",
  farmhousedecor:
    "Shop curated collection of eco friendly handcrafted signs, clocks, decor and furniture from India and South East Asia",
  monochrome:
    "Explore earthy tones, source consciously produced, furnishings, decor & kitchenware at Qalara",
  "minimalist-vibes":
    "Source curated minimalist collection of relaxed silhouettes, subtle hues, and simplicity of form in wholesale at Qalara",
  "eclectic-pop": "Shop our curated eclectic pop collection on Qalara",
  indigoblues:
    "Shop curated handcrafted indigo collection from India and South East Asia",
  oceanbreeze:
    "Anchor lamps, seashell mirrors and intricately embroidered pillows. Source curated beach vacation collection in bulk",

  // "play-and-learn": "KidsLearning",
  // noir: "Noir",
  // "tender-rose": "Rose",
  // joyful_basics: "Joyful Basics",
};
export async function getStaticPaths() {
  const posts = [
    {
      id: "earthinspired",
    },
    {
      id: "globaltextures",
    },
    {
      id: "urbanjungle",
    },
    {
      id: "homeoffice",
    },
    {
      id: "christmasspirit",
    },
    {
      id: "sunkissed-spring21",
    },
    {
      id: "play-and-learn",
    },
    {
      id: "indigoblues",
    },
    {
      id: "farmhousedecor",
    },
    {
      id: "monochrome",
    },
    {
      id: "minimalist-vibes",
    },
    {
      id: "eclectic-pop",
    },
    {
      id: "oceanbreeze",
    },
    {
      id: "noir",
    },
    {
      id: "tender-rose",
    },
    {
      id: "joyful_basics"
    },
    {
      id: "floral-country-side"
    },
    {
      id: "hyper-crafted"
    },
    {
      id: "ombre_gradient"
    }
  ];
  const paths = posts.map((post) => ({
    params: { trend: post.id },
  }));
  return {
    paths,
    fallback: true,
  };
}
export async function getStaticProps({ params: { trend = "" } = {} }) {
  let res;
  const error = { status: false };
  try {
    const response = await fetch(
      process.env.NEXT_PUBLIC_REACT_APP_CONTENT_URL +
        `/content/${trendsObj[trend.toLowerCase()]}`,
      {
        method: "GET",
        headers: {
          "content-type": "application/json",
          Authorization: "Bearer " + process.env.NEXT_PUBLIC_ANONYMOUS_TOKEN,
        },
      }
    );
    res = await response.json();
  } catch (error) {
    error["status"] = true;
  }

  return {
    props: {
      res: res || null,
      error: error,
      trend: trend.toLowerCase(),
    },
    revalidate: 14400,
  };
}
